import { InfoCircle } from 'icons/ButtonIcons/InfoCircle';
import { useState } from 'react';
import { tooltip as Tooltip } from '@/app/_components/Base/Tooltip';
import { Image } from '@/app/_components/common/Image';
import { Link } from '@/app_components/common/Link';
import { trackOptimizelyEvent } from '@/app_lib/optimizely/utils';
import { trackGtmEvent } from '@/app_lib/utils/ndrUtils';
import { cn } from '@/app_lib/utils/utils';
import useBreakpoint from '@/main/lib/hooks/useBreakpoint';
import { useOptimizely } from '@/main/lib/hooks/useOptimizely';

interface NdrHeaderProps {
  className?: string;
  disclaimerText?: string;
  disclaimerTitle?: string;
  homeUrl: string;
}

export const NdrHeader = ({ className = '', disclaimerText, disclaimerTitle, homeUrl }: NdrHeaderProps) => {
  const { optimizely } = useOptimizely();
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const handleCloseTooltip = () => {
    trackOptimizelyEvent(optimizely, 'ndr_disclosure_click', {});
    setIsTooltipOpen(false);
  };
  const isMobile = useBreakpoint('mdMax');

  return (
    <header className={cn(className, 'w-full lg:max-w-[--width-ndr] lg:mx-auto')}>
      <div className='w-full flex justify-between items-center'>
        {!isMobile && <div className='basis-1/3' />}

        <div className='flex justify-center md:basis-1/3'>
          <Link
            data-cy='ndr-logo-link'
            href={homeUrl}
            onClick={() => {
              trackGtmEvent(homeUrl);
            }}
            rel='noopener noreferrer'
            target='_blank'
          >
            <Image
              alt='NDR Logo'
              className='h-auto'
              fullWidth={false}
              height={32}
              priority
              src='/static/ndr/logo.svg'
              width={139}
            />
          </Link>
        </div>

        <div className='flex justify-end md:basis-1/3'>
          <div className='relative group'>
            <button
              aria-label='Advertiser Disclosure Information'
              className='text-neutral-900 text-sm font-medium flex items-center gap-1 transition-colors hover:underline'
              data-cy='ndr-disclaimer-button'
              onMouseEnter={() => setIsTooltipOpen(true)}
              type='button'
            >
              {disclaimerTitle || ''}
              <InfoCircle className='w-4 h-4' />
            </button>
            <Tooltip
              content={disclaimerText || ''}
              isOpen={isTooltipOpen}
              onClose={handleCloseTooltip}
              title={disclaimerTitle || ''}
            />
          </div>
        </div>
      </div>
    </header>
  );
};
